import React from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { Avatar } from '@mui/material';
import CloseIcon from '../svg/CloseIcon';
import TickIcon from '../svg/TickIcon';
import RightArrowIcon from '../svg/RightArrowIcon';
import palette from '../theme/palette';

const useStyles = makeStyles({
  container: {
    marginTop: 10,
    display: 'flex',
    padding: 10,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    backgroundColor: 'white',
    borderRadius: 8,
    alignItems: 'center',
    cursor: 'pointer'
  },
  rightIcon: {
    marginLeft: 'auto',
    marginRight: 10
  },
  leftIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // padding: 15,
    borderRadius: 6,
    marginRight: 15,
    width: 60,
    height: 60
  },
  titleStyle: {
    fontSize: 16
  },
  subTitleStyle: {
    fontSize: 13,
    color: palette.grey[500]
  }
});

export default function StudentCard({
  title,
  subTitle,
  avatarUrl,
  mark,
  onClick,
  paymentStatus,
  paymentDone
}) {
  const classes = useStyles();
  return (
    <div className={classes.container} role="presentation" onClick={() => onClick()}>
      <div className={classes.leftIconContainer}>
        <Avatar src={avatarUrl} alt={title}>
          {title.charAt(0)}
        </Avatar>
      </div>
      <div>
        <p className={classes.titleStyle}>{title}</p>
        {subTitle && <p className={classes.subTitleStyle}>{subTitle}</p>}
        {mark && (
          <p style={{ color: 'green', fontSize: 12 }}>
            <TickIcon color="green" />
            {` Marked as Done - ${mark}/100 `}
          </p>
        )}
        {paymentStatus &&
          (paymentDone ? (
            <p style={{ color: 'green', fontSize: 12 }}>
              {' '}
              <TickIcon color="green" /> Payment - Paid
            </p>
          ) : (
            <p style={{ color: 'red', fontSize: 12 }}>
              <CloseIcon color="red" /> Payment - Unpaid
            </p>
          ))}
      </div>
      <div className={classes.rightIcon}>
        <RightArrowIcon />
      </div>
    </div>
  );
}

StudentCard.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  avatarUrl: PropTypes.string,
  mark: PropTypes.number,
  onClick: PropTypes.func,
  paymentStatus: PropTypes.bool,
  paymentDone: PropTypes.bool
};
